module.exports = __webpack_public_path__ + "static/img/1ab73186ffdb2f8970d88b22cf857c7c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Mode1.png
// module id = 6v9g
// module chunks = 1